import { useQuery, useQueryClient, useMutation } from 'react-query'
import client, { deleteclient, patchclient } from './api-client';

const parcelQueryConfig = {
  staleTime: 1000 * 60 * 60,
  cacheTime: 1000 * 60 * 60,
}

async function getCustomLayerScript(layer_name, index_filter) {
  const data = await client(`custom_layers/?index_filter=${index_filter}&layer=${layer_name}`)
  return data
}

export function useCustomLayer(layer_name, index_filter) {
  return useQuery(['custom_layer', layer_name, index_filter], () => getCustomLayerScript(layer_name, index_filter), {
    refetchAllOnWindowFocus: false,
    enabled: !!layer_name && !!index_filter,
    ...parcelQueryConfig
  });
}
